// src/App.tsx
import React, { useEffect } from "react";
import {BrowserRouter, Routes, Route, Navigate} from "react-router-dom";
import telegramWebAppAPI from "./services/telegram";
import {useDispatch} from "react-redux";
import LoadScreen from "./components/LoadScreen";
import 'react-toastify/dist/ReactToastify.css';
import WelcomeScreen from "./components/WelcomeScreen";
import SocialScreen from "./components/SocialScreen";

import socData from "./components/SocialScreen/socialData.js"
import MainScreen from "./components/MainScreen";
import LeadersScreen from "./components/LeadersScreen";
import styles from "./App.module.css";

const LoadWrapper: React.FC = () => {
    return (
        <div className={styles.App}>
        <LoadScreen />
        </div>
    );
};


const App: React.FC = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        telegramWebAppAPI.init(async () => {
            telegramWebAppAPI.expand();

            let data = telegramWebAppAPI.getData();

            if (data === '') data = 'user=%7B%22id%22%3A111111111%2C%22first_name%22%3A%22Roman%20Kropivenko%22%2C%22last_name%22%3A%22%22%2C%22username%22%3A%22Test4%22%2C%22language_code%22%3A%22ua%22%2C%22allows_write_to_pm%22%3Atrue%7D&chat_instance=2180813291426588366&chat_type=private&start_param=r_1800820834&auth_date=1720097258&hash=6e8f4ec17047551ca9bea08e5a2d9a4ffa605a69916ade8f8c749dd711d8769e';

            dispatch({ type: 'game/authorize', payload: { data: data } });
            dispatch({ type: 'game/every5Minutes' });
        });
    }, [dispatch]);

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<LoadWrapper />} />
                <Route path="/welcome" element={<WelcomeScreen />} />
                <Route path="/social" element={< SocialScreen socialData={socData} />} />
                <Route path="/main" element={<MainScreen />} />
                <Route path="/leaders" element={<LeadersScreen />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </BrowserRouter>
    );
};

export default App;
